var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.checked)?_c('div',{staticClass:"loadingRead"},[_c('img',{staticClass:"loadingImg",attrs:{"src":require("../assets/loading.gif"),"alt":""}})]):_vm._e(),(_vm.checked)?_c('div'):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }